<template>
  <div
    class="org-admin-obj-types_oap org-admin-input_oai"
    v-if="objTypesList"
    :class="{ [curTheme]: true }">
    <div class="oaf_label">Тип объекта</div>
    <el-select
      v-model="objTypesLoc"
      multiple
      clearable
      @change="onChange"
      placeholder="Выберите тип объекта...">
      <el-option
        v-for="(type, i) in objTypesList"
        :key="`opt-${i}`"
        :label="type.Title"
        :value="type.Type">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {

  props: ['objTypes'],

  data() {
    return {
      objTypesLoc: this.objTypes,
    };
  },

  computed: {
    objTypesList() {
      return this.$store.getters['types/getTypes']
        .map(o => ({ Type: o.Type, Title: o.Title }));
    },
  },

  watch: {
    objTypes() {
      this.objTypesLoc = this.objTypes;
    },
  },

  methods: {
    onChange() {
      this.$emit('update:objTypes', this.objTypesLoc);
    },
  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.org-admin-obj-types_oap {
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/inputs/OrgAdminObjTypes.vue